
export type GetAdminAccountPaymentDebugParams = {
/**
 * 조회할 사용자 ID
 */
userId: string;
};
